import React from 'react'
import useTranslation from '../useTranslation'
import './LiveBowlingTable.scss'

export default function LiveBowlingTable({ scoreboard, isHundred }) {
    const R = useTranslation('R')
    const Bowler = useTranslation('Bowler')
    const W = useTranslation('W')
    const O = useTranslation('O')
    const B = useTranslation('B')

    const {
        bowler1name,
        bowler1overs,
        bowler1runs,
        bowler1wickets,
        bowler2name,
        bowler2overs,
        bowler2runs,
        bowler2wickets
    } = scoreboard || {};

    return (
        <div className="live-bowling-table">
            <div className="live-bowling-table-header">
                <div>{Bowler}</div>
                <div>{isHundred ? B : O}</div>
                <div>{R}</div>
                <div>{W}</div>
            </div>
            <div className="live-bowling-table-row">
                <div>{bowler1name}</div>
                <div>{bowler1overs}</div>
                <div>{bowler1runs}</div>
                <div>{bowler1wickets}</div>
            </div>
            <div className="live-bowling-table-row">
                <div>{bowler2name}</div>
                <div>{bowler2overs}</div>
                <div>{bowler2runs}</div>
                <div>{bowler2wickets}</div>
            </div>
        </div>
    )
}
